import { SPI, RouterWidget, LoginPageWidget } from '@kunlun/dependencies';
import LoginComponent from './Login.vue';

@SPI.ClassFactory(RouterWidget.Token({ widget: 'Login' }))
export class CustomLoginPageWidget extends LoginPageWidget {
  public initialize(config) {
    super.initialize(config);

    this.setComponent(LoginComponent);

    return this;
  }
}
